<template>
  <v-form ref="form">
    <v-card-text>
      <v-row>
        <v-col>
          <v-text-field filled
                        hide-details="auto"
                        v-bind:label="$t('title')"
                        v-bind:rules="[ rules.required ]"
                        v-model="subject.title" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field filled
                        hide-details="auto"
                        type="number"
                        v-bind:label="$t('examQuestionCount')"
                        v-bind:rules="[ rules.required ]"
                        v-model="subject.examQuestionCount" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('global.pleaseFillOutThisField')
        }
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'SubjectDetails',
    props: {
      subject: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "examQuestionCount": "Anzahl der Prüfungsfragen",
      "title": "Bezeichnung"
    },
    "en": {
      "examQuestionCount": "Exam question count",
      "title": "Title"
    }
  }
</i18n>